import React, {ReactNode} from 'react';
import NetworkErrorBlock from './NetworkErrorBlock';

export default class NetworkError extends React.Component {
  public render(): null | ReactNode {
    return <NetworkErrorBlock />;
  }
}
